<template>
  <div class="px-1">
  <nav class="navbar navbar-expand-lg opcionesMenuCorrespondencia fixed-top bg-white py-1">
    <div class="container-fluid">
      <a class="navbar-brand" href="#">
        <div class="grid">

          <!--SVG escudo -->
          <div class="col-2 mt-1 mx-1">
            <a href="" class="nav_logo">
              <svg version="1.1" id="EscudoLogoNavBar" xmlns="http://www.w3.org/2000/svg" x="0" y="0"
                viewBox="0 0 330 500" style="enable-background: new 0 0 330 500" xml:space="preserve">
                <path class="EscudoLogost0"
                  d="M212.14 221c-.09.05-.18.11-.27.17-.09.06-.18.12-.26.19-.02.02-.04.03-.06.04-.04.03-.07.08-.11.12-.08.08-.17.17-.25.27-.05.07-.1.14-.14.21-.06.08-.12.18-.16.27-.04.08-.08.17-.12.26-.03.09-.07.18-.1.27-.03.09-.04.19-.07.28-.02.09-.03.19-.04.29-.01.09-.01.2-.01.29s0 .19.01.29c.01.1.03.2.05.31.02.08.03.18.06.26.03.11.08.21.12.31.03.06.03.11.07.17.01.02.03.03.03.05.11.21.24.42.41.6l.04.05.01.01 12.27 13.81.03.03c.04.05.09.08.14.13.14.14.29.26.45.36.07.04.14.08.2.12.16.08.33.16.5.22.07.03.13.04.2.07.24.06.48.1.74.1h.01c.2 0 .41-.03.61-.07.06-.01.12-.03.18-.05.15-.04.3-.09.44-.16.03-.02.08-.03.11-.04.07-.03 6.83-3.38 13.44-3.38 6.56 0 13.38 3.34 13.44 3.38.04.03.09.03.14.05.1.04.21.08.31.12.08.03.14.04.22.06.12.03.23.04.35.06.07.01.14.02.2.02.03 0 .08.01.11.01.07 0 .14-.02.2-.03l.29-.03c.1-.02.2-.04.31-.07.09-.03.18-.05.26-.08.1-.03.2-.08.29-.13.08-.04.17-.09.25-.14.08-.05.16-.11.25-.17.09-.07.18-.15.25-.24.04-.04.09-.08.14-.12L270 225.68c.02-.03.03-.05.05-.07.07-.08.13-.16.18-.25.06-.08.12-.17.17-.26.02-.03.03-.04.04-.07.03-.05.04-.11.06-.17.04-.1.08-.21.12-.31.03-.08.04-.17.06-.25.03-.1.04-.2.05-.31.01-.09.01-.19.01-.27 0-.1 0-.2-.01-.31-.01-.09-.03-.18-.04-.26-.02-.1-.04-.2-.07-.31-.03-.08-.06-.17-.09-.25-.03-.09-.08-.19-.13-.28-.04-.08-.09-.17-.15-.25-.05-.08-.1-.16-.16-.23-.07-.09-.15-.17-.23-.25-.04-.04-.08-.08-.12-.13-.02-.02-.04-.03-.06-.04-.08-.07-.17-.13-.26-.19-.08-.06-.17-.12-.25-.16-.03-.02-.04-.03-.07-.04-.58-.29-14.35-7.1-28.46-7.1-14.11 0-27.87 6.81-28.46 7.1 0-.06-.02-.04-.04-.02zm50.62 3.75-8.11 9.12c-2.91-1.19-8.39-3.06-14-3.06s-11.09 1.88-14 3.06l-8.11-9.12c4.77-1.91 13.5-4.86 22.1-4.86 8.62 0 17.35 2.95 22.12 4.86zM253.1 244.65c-.25-.13-6.25-3.09-12.43-3.09-6.19 0-12.19 2.96-12.44 3.09a3.015 3.015 0 0 0-1.35 4.04 3.024 3.024 0 0 0 4.04 1.36c.05-.03 5.01-2.45 9.74-2.45 4.74 0 9.69 2.43 9.74 2.45.43.21.88.31 1.34.31 1.1 0 2.17-.61 2.71-1.67.74-1.48.14-3.29-1.35-4.04zM210.56 137.89c.01.1.03.2.05.31.02.08.03.18.06.26.03.11.08.21.12.31.03.06.03.11.07.17.02.03.03.04.04.07.05.09.11.18.17.26.06.08.12.17.19.25.02.03.03.05.05.07l12.32 13.86.03.03c.04.05.09.08.14.13.14.14.29.26.45.36.07.04.14.08.2.12.16.08.33.16.5.22.07.03.13.04.2.06.25.06.48.1.74.1h.01c.2 0 .41-.03.61-.07.06-.01.12-.03.18-.05.15-.04.3-.09.44-.16.03-.02.08-.03.11-.04.07-.03 6.83-3.38 13.44-3.38 6.56 0 13.38 3.34 13.44 3.38.04.03.09.03.14.05.1.04.21.08.31.12.08.03.14.04.22.06.12.03.23.04.35.06.07.01.14.02.21.02.03 0 .08.01.11.01.07 0 .14-.02.2-.03l.29-.03c.1-.02.2-.04.31-.08.09-.03.18-.05.26-.08.1-.03.2-.08.29-.13.08-.04.17-.09.25-.14.08-.05.16-.11.25-.17.09-.07.18-.15.25-.24.04-.04.09-.08.14-.12l12.27-13.81.01-.01.04-.05c.17-.19.3-.39.41-.6.01-.02.03-.03.03-.05.03-.05.04-.11.07-.17.04-.1.08-.21.12-.31.03-.08.04-.17.06-.25.03-.1.04-.2.05-.31.01-.09.01-.19.01-.27 0-.1 0-.2-.01-.31-.01-.09-.03-.18-.04-.26-.02-.1-.04-.2-.07-.31-.03-.08-.06-.17-.09-.25-.03-.09-.08-.19-.13-.28-.04-.08-.09-.17-.15-.25-.05-.08-.1-.16-.16-.23-.07-.09-.15-.17-.23-.25-.04-.04-.08-.08-.12-.13-.02-.02-.04-.03-.06-.04-.08-.07-.17-.13-.26-.19-.08-.06-.17-.12-.26-.16-.03-.02-.04-.03-.07-.04-.58-.29-14.35-7.1-28.46-7.1-14.11 0-27.87 6.81-28.46 7.1-.03.01-.04.03-.07.04-.09.05-.18.11-.27.17-.09.06-.18.12-.26.19-.02.02-.04.03-.06.04-.04.03-.07.08-.11.12-.08.08-.17.17-.25.27-.05.07-.1.14-.14.21-.06.08-.12.18-.16.27-.04.08-.08.17-.12.26-.03.09-.07.18-.1.27-.03.09-.04.19-.07.28-.02.09-.03.19-.04.29-.01.09-.01.2-.01.29.01.08.01.18.02.27zm52.2.81-8.11 9.12c-2.91-1.19-8.39-3.06-14-3.06s-11.09 1.88-14 3.06l-8.11-9.12c4.77-1.91 13.5-4.86 22.1-4.86s17.35 2.95 22.12 4.86zM230.91 164.01c.05-.03 5.01-2.46 9.74-2.46 4.74 0 9.69 2.44 9.74 2.45.43.21.89.31 1.34.31 1.1 0 2.17-.61 2.71-1.67.74-1.49.14-3.29-1.35-4.04-.25-.13-6.25-3.09-12.43-3.09-6.19 0-12.19 2.96-12.44 3.09a3.015 3.015 0 0 0-1.35 4.04 3.01 3.01 0 0 0 4.04 1.37zM175.94 178.45c-.08.05-.17.1-.25.16-.09.06-.19.13-.26.2-.02.02-.04.03-.06.04-.04.03-.07.08-.11.12-.08.08-.17.17-.25.26l-.15.21c-.06.08-.12.18-.16.27-.04.08-.08.17-.12.26-.03.09-.07.18-.1.27-.03.09-.05.19-.07.28-.02.09-.03.19-.04.28s-.01.2-.01.29 0 .19.01.29.03.2.05.31c.02.08.03.18.06.26.03.11.08.21.12.31.03.06.03.11.07.17.01.02.03.03.03.05.11.21.24.42.41.6l.04.05.01.01 12.27 13.81c.01.01.02.02.03.02.04.05.09.08.14.13.14.14.29.26.45.36.07.04.14.08.2.12.16.08.33.16.5.22.07.03.13.04.2.07.24.06.48.1.74.1h.01c.2 0 .41-.03.61-.07.06-.01.12-.03.18-.05.15-.04.3-.09.44-.16.03-.02.08-.03.11-.04.07-.03 6.83-3.38 13.44-3.38 6.56 0 13.38 3.34 13.44 3.38.04.03.09.03.14.05.11.05.22.08.33.12.07.02.14.04.2.05.13.03.25.05.38.06.06.01.12.02.18.02.04 0 .08.01.12.01.08 0 .15-.02.23-.03l.26-.03c.11-.02.22-.04.32-.08.08-.03.17-.05.25-.08.1-.03.2-.08.29-.13.09-.04.18-.09.26-.15.08-.05.16-.1.24-.16.09-.08.19-.16.27-.25.04-.04.08-.07.13-.12l12.32-13.86c.02-.03.03-.05.05-.08.06-.08.12-.16.18-.25.06-.08.12-.18.17-.27.02-.03.03-.04.04-.07.03-.05.04-.11.07-.17.04-.1.08-.21.12-.31.03-.08.04-.17.06-.25.02-.1.04-.2.05-.31.01-.09.01-.19.01-.27 0-.1 0-.2-.01-.31-.01-.09-.03-.18-.04-.26-.02-.1-.04-.2-.07-.31-.03-.08-.06-.17-.09-.25-.03-.09-.08-.19-.13-.28-.04-.08-.09-.17-.15-.25-.05-.08-.1-.16-.16-.23-.07-.09-.15-.17-.23-.25-.04-.04-.08-.08-.12-.13-.02-.02-.04-.03-.06-.04-.08-.07-.18-.14-.27-.2-.08-.05-.16-.11-.25-.15-.03-.02-.05-.03-.08-.05-.58-.29-14.35-7.1-28.46-7.1-14.11 0-27.87 6.81-28.46 7.1-.02.04-.04.06-.07.07zm50.63 3.76-8.1 9.12c-2.91-1.19-8.39-3.06-14-3.06-5.6 0-11.09 1.88-14 3.06l-8.11-9.12c4.77-1.91 13.5-4.86 22.1-4.86 8.6-.01 17.35 2.94 22.11 4.86zM216.91 202.11c-.25-.13-6.25-3.09-12.43-3.09-6.19 0-12.19 2.96-12.44 3.09a3.015 3.015 0 0 0-1.35 4.04 3.024 3.024 0 0 0 4.04 1.36c.05-.03 5.01-2.46 9.74-2.46 4.74 0 9.69 2.44 9.74 2.45.43.21.89.31 1.34.31 1.1 0 2.17-.61 2.71-1.67.74-1.48.13-3.28-1.35-4.03zM265.31 383.38c-.42-.33-10.41-8.01-20.81-8.01-7.89 0-15.54 4.42-18.95 6.7-3.41-2.27-11.07-6.7-18.95-6.7-10.39 0-20.39 7.68-20.81 8.01-1.32 1.02-1.55 2.92-.53 4.24.59.76 1.49 1.16 2.39 1.16.65 0 1.3-.2 1.85-.64.08-.07 8.76-6.74 17.1-6.74 8.3 0 17.02 6.67 17.1 6.74.08.06.16.1.24.15.07.04.13.08.2.12.1.06.21.1.32.14.08.03.15.06.23.08.1.03.21.05.31.07.08.02.17.03.26.04.1.01.2.01.3.01s.2 0 .3-.01c.08-.01.17-.03.26-.04.1-.02.21-.04.31-.07.08-.03.15-.06.23-.08.1-.04.21-.08.31-.14.07-.03.14-.08.2-.13.08-.05.16-.08.23-.14.08-.07 8.8-6.74 17.1-6.74s17.03 6.67 17.11 6.74a3.04 3.04 0 0 0 4.24-.53c1.02-1.32.78-3.21-.54-4.23zM184.67 371.46l.03.23c.03.1.06.2.09.31.03.09.06.18.1.27.03.08.08.15.13.23.06.1.12.2.19.3.02.03.03.05.04.07l.08.08c.1.13.21.24.34.34.05.04.09.08.14.12.14.1.27.19.42.27.04.02.08.04.12.07.39.18.81.29 1.27.29.1 0 .2-.02.29-.03.08-.01.14-.01.22-.03.11-.02.22-.05.32-.08.06-.02.13-.03.19-.06.11-.04.21-.08.31-.14.06-.03.12-.06.17-.09.09-.06.2-.12.28-.18.02-.02.04-.03.06-.03.08-.07 8.8-6.74 17.11-6.74s17.02 6.67 17.1 6.74c.03.02.05.03.08.05.1.08.21.14.32.2.05.03.09.06.14.08.02.01.03.02.05.02.12.05.24.09.36.14.06.02.12.04.19.06.01 0 .02.01.03.01.02 0 .03.01.04.01.1.03.2.03.31.04l.21.03c.04 0 .08.02.14.02.05 0 .09-.01.14-.02.05 0 .1-.01.15-.01.04 0 .08-.01.12-.01.04-.01.08-.01.13-.02.08-.02.16-.04.25-.06.09-.03.19-.05.28-.08.08-.03.17-.07.25-.11.05-.03.1-.05.15-.08.03-.02.04-.03.07-.04 0 0 .01 0 .01-.01.08-.05.17-.1.25-.16.03-.02.05-.03.07-.04.08-.07 8.76-6.74 17.1-6.74 8.3 0 17.03 6.67 17.11 6.74.02.02.04.03.06.04.11.08.23.15.36.22.05.03.1.06.15.08.13.06.25.1.39.14.05.02.11.03.16.05.13.03.25.05.39.06.07.01.14.02.2.02.04 0 .08.02.14.02.08 0 .16-.02.25-.03.07-.01.14-.01.21-.03.13-.02.25-.05.37-.08.07-.02.13-.03.2-.06.12-.04.24-.09.35-.15.06-.03.12-.06.18-.1.11-.07.21-.14.31-.22a2.621 2.621 0 0 0 .43-.43c.03-.03.06-.05.08-.08.02-.02.03-.03.03-.05.08-.11.15-.22.21-.34.03-.06.07-.12.09-.18.05-.1.08-.21.13-.33.03-.08.06-.16.08-.24.03-.09.03-.2.05-.3.02-.1.03-.2.03-.31 0-.03.01-.06.01-.09V326.8c0-.06-.02-.12-.02-.18l-.03-.32c-.02-.09-.03-.18-.06-.26-.03-.1-.06-.2-.09-.31-.03-.08-.07-.16-.1-.24-.05-.1-.09-.2-.15-.29-.04-.08-.09-.14-.14-.21-.07-.08-.13-.17-.2-.25-.07-.07-.14-.13-.2-.2-.05-.04-.09-.09-.14-.14-.42-.33-10.41-8-20.81-8-7.89 0-15.53 4.41-18.95 6.7-3.42-2.27-11.08-6.7-18.95-6.7-10.39 0-20.39 7.68-20.81 8-.06.05-.11.1-.16.15-.06.05-.12.1-.17.16-.08.09-.16.19-.24.29a2.502 2.502 0 0 0-.3.5c-.03.06-.06.13-.08.19-.04.12-.08.24-.11.36-.02.07-.03.14-.04.2-.03.13-.03.25-.04.39 0 .04-.02.08-.02.14v44.23c0 .03.01.05.01.08-.05.13-.04.25-.01.37zm75.78-43.13v37.13c-3.97-2.24-9.88-4.86-15.94-4.86-6.06 0-11.97 2.61-15.94 4.85v-37.14c2.65-1.8 9.41-5.91 15.94-5.91 6.53.03 13.29 4.14 15.94 5.93zm-37.91.01v37.13c-3.97-2.24-9.88-4.86-15.94-4.86s-11.97 2.61-15.94 4.85v-37.14c2.65-1.8 9.41-5.91 15.94-5.91 6.52.02 13.3 4.13 15.94 5.93zM189.36 80.09c-7.02-15.51-14.8-29.85-24.12-29.85-9.33 0-17.11 14.34-24.12 29.86l-1.21 2.65c-3.32 7.03-6.75 14.29-6.75 21.81 0 5.07 4.61 9.85 9.48 9.85 1.82 0 4.32-.94 8.95-2.76 4.41-1.72 10.44-4.08 13.66-4.08 3.22 0 9.25 2.36 13.66 4.08 4.63 1.81 7.13 2.76 8.95 2.76 4.87 0 9.48-4.8 9.48-9.85 0-7.51-3.43-14.78-6.75-21.81l-1.23-2.66zm-1.5 28.28c-.92-.05-4.3-1.38-6.77-2.34-5.39-2.11-11.5-4.5-15.86-4.5-4.35 0-10.47 2.39-15.86 4.5-2.47.97-5.86 2.29-6.76 2.34-1.44 0-3.45-1.93-3.45-3.83 0-6.16 3-12.51 6.17-19.23l1.26-2.74c2.95-6.51 11.91-26.31 18.63-26.31 6.71 0 15.69 19.8 18.63 26.31l1.26 2.74c3.17 6.72 6.17 13.07 6.17 19.23.01 1.9-1.99 3.83-3.42 3.83z" />
                <path class="EscudoLogost0"
                  d="M124.18 105.29c1.66 0 3.01-1.35 3.01-3.01 0-1.66-1.35-3.01-3.01-3.01H44.6c-1.66 0-3.01 1.35-3.01 3.01v307.61c0 6.84 4.63 12.69 12.23 15.3l85.94 24.39c7.61 2.15 16.38 5.08 23.65 10.66.15.12.31.21.48.3.04.03.08.03.14.06.15.07.31.12.46.16.05.02.1.03.15.03.2.04.4.07.6.07.2 0 .4-.03.6-.07.05-.01.1-.03.15-.03.15-.04.31-.09.46-.16.04-.02.08-.03.14-.06.17-.08.33-.18.48-.3 7.27-5.58 16.03-8.52 23.66-10.66l86.08-24.45c7.45-2.56 12.07-8.41 12.07-15.25V102.27c0-1.66-1.35-3.01-3.01-3.01H206.3c-1.66 0-3.01 1.35-3.01 3.01 0 1.66 1.35 3.01 3.01 3.01h76.56v168.89H168.25V262.2c.12-.5.13-1.02 0-1.51V116.76c0-1.66-1.35-3.01-3.01-3.01-1.66 0-3.01 1.35-3.01 3.01v49.19c-.7.8-1.51 1.66-2.44 2.65-5.52 5.87-15.06 16.03-23.51 35.11-8.51-16.6-13.08-24.69-15.02-26.63a43.696 43.696 0 0 0-3.06-2.8c-.03-.03-.06-.05-.08-.07-3.4-2.83-6.17-4.24-7.86-4.9l.03-.12c.06-.31.06-.63.03-.93 4.81-.01 8.63-1.3 8.95-1.41l2.5-.87-2.69-13.13 3.79-4.86-1.18-1.8c-.28-.43-5.38-8.2-9.4-13.65-.02-.02-.03-.03-.04-.06-1.32-1.8-2.54-3.34-3.41-4.28-4.87-5.21-15.69-4-23.61 2.67-11.04 9.29-7.55 23.8-4.14 30.23-.85-.1-1.86-.29-3.07-.66-4.44-1.38-6.82-3.14-6.83-3.15a3.023 3.023 0 0 0-4.23.56 3.023 3.023 0 0 0 .56 4.23c.31.24 3.27 2.43 8.72 4.12.74.23 1.43.4 2.08.54-4.3 1-9.21 2.86-12.68 6.33-4.43 4.43-12.69 15.33-17.96 22.46v-90.25h76.5zm-57.9 103.05 4.84 19.36c-2.29 4.73-11.82 25.01-16.74 45.36-.09.38-.1.76-.05 1.12h-6.71v-42.04l18.66-23.8zm19.23-36.6 12.2 30.77v1.05c-10.7-8.43-16.15-24.52-17.99-30.96 2.25-.5 4.34-.75 5.79-.86zm28.43 67.96c-2.44-2.17-4.07-4.1-5.14-5.6 1.29-.31 2.51-.6 3.67-.87 3.65-.86 6.82-1.6 9.95-2.69-2.49 3.04-5.34 6.12-8.48 9.16zm-10.2-2.32c1.26 1.82 3.1 4.01 5.75 6.43a144.22 144.22 0 0 1-5.75 4.78v-11.21zm-4.85-16.47c1.89-1.27 3.47-1.52 4.7-.75 1.63 1.02 2.41 3.4 2.24 4.6-.22 1.54-1.59 3.06-3.23 4.2-.17.09-.33.2-.48.31-1.53.97-3.22 1.6-4.41 1.6h-.06c-1.41-.03-2.21-1.21-3.39-3.72l-.31-.64c-.48-1.52-.02-2.27 4.94-5.6zm0 38.07c.09.13.19.25.31.37l14.79 14.82H71.72c7.31-8.22 14.01-10.43 19.96-12.38 2.53-.83 4.95-1.63 7.21-2.81zm63.33 21.23v58.51H146.1l-3.49-42.46c-.01-.07-.03-.14-.03-.2-.02-.08-.03-.17-.04-.25-.03-.13-.07-.24-.11-.36-.03-.06-.04-.12-.07-.17-.06-.14-.14-.26-.21-.39-.02-.03-.04-.07-.06-.09-.09-.13-.19-.25-.3-.36l-.08-.08c-.1-.1-.21-.2-.33-.27-.05-.03-.09-.07-.14-.1-.09-.06-.2-.11-.31-.16a2.03 2.03 0 0 0-.26-.11c-.08-.03-.16-.05-.24-.08-.12-.03-.24-.06-.36-.08l-.23-.03c-.08-.01-.15-.03-.24-.03h-9.05c-.08 0-.14.02-.22.03l-.25.03c-.11.02-.22.04-.33.08-.09.03-.18.05-.27.08-.08.03-.16.07-.24.1-.11.05-.22.11-.32.17a.85.85 0 0 1-.14.09c-.12.08-.24.18-.34.28l-.08.08c-.11.11-.2.23-.3.36-.03.03-.04.07-.07.1-.08.12-.14.25-.2.38-.03.06-.05.12-.07.18-.04.12-.08.23-.11.36-.02.08-.03.17-.05.26-.01.07-.03.13-.03.2l-3.49 42.46h-16.12v-15.08c0-.07-.02-.13-.02-.19l-.03-.33c-.02-.1-.04-.2-.07-.29-.03-.09-.05-.19-.08-.27-.04-.11-.09-.21-.14-.31-.03-.05-.04-.11-.08-.16-.01-.02-.03-.03-.04-.06a2.56 2.56 0 0 0-.2-.26c-.06-.07-.11-.14-.17-.21-.07-.07-.14-.13-.2-.19-.08-.07-.15-.14-.24-.2-.07-.05-.14-.08-.22-.13-.09-.05-.19-.11-.29-.15-.08-.03-.15-.06-.24-.08-.11-.03-.21-.08-.32-.1a.908.908 0 0 0-.23-.03 2.28 2.28 0 0 0-.36-.03c-.03 0-.04-.01-.07-.01-.06 0-.11.02-.17.02l-.36.03c-.09.02-.18.04-.27.07-.09.03-.19.05-.29.08-.11.04-.2.09-.31.14-.05.03-.11.04-.16.08l-25.59 15.35v-12.77c0-.07-.02-.13-.02-.19l-.03-.33c-.02-.1-.04-.2-.07-.29-.03-.09-.05-.19-.08-.27-.04-.11-.09-.21-.14-.31-.03-.05-.04-.11-.08-.16-.01-.02-.03-.03-.04-.06-.06-.09-.14-.19-.2-.27-.05-.07-.1-.14-.16-.2-.07-.07-.14-.14-.22-.2-.08-.06-.14-.13-.22-.19-.08-.05-.15-.09-.24-.14-.08-.05-.18-.1-.27-.14-.08-.03-.16-.06-.25-.08-.1-.03-.2-.08-.31-.09a.908.908 0 0 0-.23-.03 2.28 2.28 0 0 0-.36-.03c-.03 0-.04-.01-.07-.01-.06 0-.11.02-.17.02l-.36.03c-.09.02-.18.04-.27.07-.09.03-.2.05-.29.08-.11.04-.2.09-.31.14-.05.03-.11.04-.16.08l-25.59 15.35v-56.2l114.59-.03zM55.62 419.44c-3.87-1.33-8-4.54-8-9.55v-66.44l24.12-14.47v12.77c0 .07.02.13.02.19l.03.33c.02.1.04.2.07.29.03.09.05.19.08.27.04.11.09.21.14.31.03.05.04.11.08.16.01.02.03.03.03.04.13.2.27.39.44.56.03.03.07.05.1.08.14.13.3.24.46.34.06.03.12.07.19.1.15.08.31.14.48.2.06.02.12.04.18.05.22.05.46.08.7.08h.01c.25 0 .48-.04.7-.09.06-.02.12-.03.19-.06.2-.06.37-.14.55-.24.03-.02.07-.03.1-.04l25.59-15.35v12.77c0 1.66 1.35 3.01 3.01 3.01h21.92c.2 0 .4-.03.59-.06.07-.02.14-.04.2-.06.12-.03.24-.06.35-.11.08-.03.15-.08.22-.11.09-.05.19-.09.28-.15.07-.04.14-.1.2-.15.08-.07.16-.13.24-.2.06-.06.11-.12.17-.19.07-.08.14-.16.2-.25.05-.07.08-.14.13-.2.06-.09.11-.19.15-.29.03-.08.06-.15.08-.23.03-.1.08-.2.1-.31.02-.08.03-.17.04-.25.01-.07.03-.14.03-.2l3.49-42.46h3.49l3.49 42.46c.01.07.03.14.03.2.02.08.03.17.04.25.03.11.06.21.1.31.03.08.05.15.08.23.04.1.1.2.15.29.04.07.08.14.13.2.06.08.14.17.2.25.05.06.11.13.17.19.08.08.16.14.24.2.07.05.13.11.2.15.08.06.19.1.28.15.08.03.14.08.22.11.11.04.23.08.35.11l.2.06c.2.03.39.06.59.06h18.9v107.42c-6.85-4.11-14.25-6.54-20.82-8.39l-85.7-24.34zm227.23-139.23v129.68c0 5.01-4.13 8.22-7.84 9.5l-85.92 24.39c-6.57 1.85-13.97 4.28-20.83 8.39V280.21h114.59zm-161.53-6.04c-.02-.75-.31-1.49-.87-2.07l-16.24-16.27c3.22-2.39 6.62-5.15 10-8.18 4.36 3.19 10.13 6.56 17.77 9.78 15.18 6.39 23.98 8.11 29.07 8.11.42 0 .81-.02 1.18-.03v8.67l-40.91-.01zm40.9-99.34v84.58c-2.83.25-10.53-.24-27.92-7.55-6.67-2.81-11.76-5.7-15.62-8.42 8.24-8.08 15.67-17.46 18.78-26.36 8.09-23.05 18.01-34.95 24.76-42.25zm-28.97 36.24c-.49 1.31-.98 2.63-1.47 4.01-.58 1.64-1.37 3.36-2.33 5.14-6.23 4.26-10.79 5.37-18.07 7.08.19-.54.34-1.09.42-1.67.31-2.13-.27-4.9-1.76-7.26l15.05-9.46c1.41-.88 1.83-2.75.95-4.16a3.025 3.025 0 0 0-4.16-.95l-16.67 10.47c-.45-.17-.94-.31-1.49-.42v-1.44c9.01-8.79 12.9-21.73 14.5-29.34 1.88 2.95 6.01 10.27 15.03 28zm-20.22-33.19c-.64 4.2-2.89 15.93-9.29 25.19v-.86l5.32-26.83c.98.48 2.33 1.26 3.97 2.5zm1.69-16.09c-3.82.72-11.01 1.17-15.22-4.21a3.03 3.03 0 0 0-4.24-.52 3.03 3.03 0 0 0-.52 4.24c2.78 3.56 6.28 5.42 9.74 6.29-.05.14-.1.29-.14.44l-4.67 23.55-9.36-24c-.01-.03-.01-.05-.02-.08-.02-.06-2.09-5.87 3.25-17.65 3.39-7.48 11.38-10.89 15.01-12.1 2.37 3.31 5.04 7.26 6.84 9.96l-2.83 3.65 2.16 10.43zM89.06 135.5c6.15-5.18 13.3-5.34 15.33-3.17.1.11.23.25.35.39-4.97 1.94-12.84 6.22-16.66 14.63-1.34 2.96-2.27 5.62-2.92 8-1.62-4.64-3.41-13.71 3.9-19.85zm-41.38 70.19c.15-.22 15.8-21.99 22.16-28.34 1.16-1.16 2.6-2.08 4.14-2.82 2.27 7.98 9.16 27.73 23.72 36.33v3.88c-.8.36-1.63.8-2.5 1.38-4.09 2.74-9.18 6.15-6.85 12.57l.48 1.02c1.08 2.3 3.33 7.09 8.73 7.18h.14v15.76c-2.13 1.5-4.73 2.35-7.9 3.4-6.84 2.25-15.36 5.05-24.44 16.28-.44.54-.65 1.19-.66 1.83h-4.39C65.66 252.2 76.89 229.6 77 229.37c.03-.05.03-.1.06-.15.04-.09.08-.2.11-.3.03-.09.05-.19.08-.28.02-.09.03-.19.05-.29.01-.1.02-.21.02-.31 0-.08 0-.18-.01-.26-.01-.12-.03-.24-.05-.35-.01-.04-.01-.09-.02-.14l-6.6-26.41c-.01-.03-.02-.05-.03-.08-.03-.12-.08-.23-.13-.35-.03-.08-.06-.14-.09-.22-.05-.09-.11-.19-.17-.28-.05-.08-.09-.15-.15-.22-.06-.08-.13-.14-.2-.22-.07-.08-.14-.14-.22-.21-.03-.03-.05-.05-.08-.07-.05-.04-.11-.07-.16-.1-.08-.05-.15-.11-.24-.15-.1-.05-.2-.1-.31-.14-.08-.03-.14-.06-.22-.08-.12-.03-.23-.07-.35-.09a.761.761 0 0 0-.21-.03c-.13-.02-.25-.02-.37-.02-.07 0-.14 0-.2.01-.14.01-.27.03-.4.06-.04.01-.08.01-.12.02-.03.01-.04.02-.06.03-.14.03-.25.08-.38.14-.06.03-.12.05-.18.08-.11.05-.21.12-.31.19-.07.04-.14.08-.2.14l-.24.21c-.07.07-.14.14-.2.21l-.08.08-17.71 22.59v-16.59c.01-.05.04-.07.05-.1z" />
                <path class="EscudoLogost0"
                  d="M310 75.13H198.41c-1.66 0-3.01 1.35-3.01 3.01 0 1.66 1.35 3.01 3.01 3.01h108.56v328.73c0 15.12-10.5 27.58-27.97 33.29l-84.45 24.12c-.01 0-.02.01-.03.01s-.02 0-.03.01c-16.41 5.03-25.19 11.94-29.27 16.06-4.08-4.12-12.87-11.02-29.27-16.06-.01 0-.02 0-.03-.01-.01 0-.02-.01-.03-.01L51.55 443.2C34 437.46 23.5 425.01 23.5 409.89V81.16h108.55c1.66 0 3.01-1.35 3.01-3.01 0-1.66-1.35-3.01-3.01-3.01H20.47c-1.66 0-3.01 1.35-3.01 3.01v331.74c0 17.6 12.35 32.56 32.35 39.09l84.4 24.11c15.35 4.72 24.84 11.7 28.62 16.65.02.03.04.03.06.06.09.12.21.23.33.34.05.04.1.1.15.14.02.01.03.03.03.03.15.12.31.21.48.3.04.02.08.03.13.05.15.07.31.13.47.16.05.02.1.03.15.03.2.04.4.07.6.07.2 0 .4-.03.6-.07.05-.01.1-.03.15-.03.16-.04.31-.09.48-.16.04-.02.08-.03.12-.05.16-.08.32-.18.48-.3.02-.01.03-.03.03-.03.06-.04.11-.1.16-.15.11-.1.22-.21.31-.33.02-.03.04-.03.06-.06 3.77-4.96 13.27-11.94 28.62-16.65l84.51-24.15c19.89-6.49 32.24-21.46 32.24-39.05V78.14a2.983 2.983 0 0 0-2.99-3.01zM117.52 43.02l-.12.27c-.03.09-.07.19-.09.28-.03.09-.04.19-.06.28-.02.1-.03.2-.04.3-.01.09-.01.19 0 .28 0 .1.01.2.02.31.01.09.03.18.05.27.03.11.05.21.08.32.01.03.02.08.03.11.03.06.06.12.08.18.03.06.05.12.08.18.07.13.14.25.23.36.03.03.04.06.06.09.11.14.23.26.36.38.04.03.08.07.13.1.1.08.2.15.32.22.03.02.06.04.08.06l.06.03c.2.1.4.19.61.25.04.01.08.02.14.03.21.05.43.08.66.08h.01c.23 0 .46-.03.69-.09.06-.02.12-.03.19-.05.06-.02.13-.03.2-.05l22.32-8.41c6.33 3.38 16.39 7.08 30.07 7.08 25.35 0 38.2-12.55 38.73-13.08.59-.59.88-1.36.88-2.13 0-.77-.29-1.54-.88-2.13-.57-.54-13.41-13.1-38.76-13.1-13.61 0-23.64 3.67-29.95 7.01l-22.46-8.34c-.04-.02-.09-.02-.14-.03-.08-.03-.17-.05-.25-.07-.11-.03-.21-.05-.32-.06-.08-.01-.17-.01-.25-.02-.11 0-.22-.01-.33 0-.08.01-.16.03-.25.03-.11.02-.22.04-.33.07-.08.03-.15.05-.24.08-.11.04-.21.08-.31.14-.03.02-.07.03-.1.04-.04.03-.08.06-.12.08-.09.06-.19.13-.28.2-.07.05-.14.11-.2.17-.08.08-.15.15-.22.23-.06.07-.12.14-.17.22-.06.08-.11.16-.16.25s-.09.18-.14.27c-.03.05-.05.09-.08.14-.02.04-.02.08-.03.12a3.327 3.327 0 0 0-.13.59c-.01.09-.02.2-.02.29v.29c.01.09.03.2.04.29s.03.19.06.28c.03.09.06.19.09.27.03.09.08.19.12.28.02.03.03.08.05.11l6.85 12.25-6.85 12.25c.02.07.01.12-.01.15zm87.91-12.37c-4.64 3.28-15.27 9.18-31.77 9.18-13.31 0-22.76-3.79-28.35-6.99a2.94 2.94 0 0 0-.51-.23c-.03-.01-.06-.03-.09-.03-.14-.04-.28-.07-.42-.09-.07-.01-.14-.03-.2-.03-.1-.01-.21-.01-.31-.01-.11 0-.21.01-.32.02-.07.01-.13.02-.19.03-.15.03-.31.07-.46.12-.01 0-.03.01-.03.01l-15.91 5.99 4.46-8-4.49-8.04 16.07 5.97c.05.02.09.03.14.04.08.03.14.04.22.06.11.03.22.04.33.06.08.01.14.02.22.02.04 0 .08.01.14.01.08 0 .16-.01.24-.02.05 0 .1-.01.15-.01.18-.03.35-.06.52-.11.03-.01.04-.02.07-.03.15-.05.3-.12.44-.2l.06-.03c5.57-3.15 14.98-6.91 28.22-6.91 16.5.04 27.13 5.94 31.77 9.22z" />
                <path class="EscudoLogost0"
                  d="M128.79 381.78h-3.17c-.24-1.65-.62-3.24-1.22-4.74l2.71-1.56a3.008 3.008 0 0 0 1.1-4.12c-.84-1.44-2.69-1.94-4.12-1.1l-2.76 1.6a20.853 20.853 0 0 0-3.45-3.45l1.6-2.76c.83-1.44.34-3.28-1.1-4.12-1.44-.85-3.29-.34-4.12 1.1l-1.56 2.71c-1.5-.6-3.1-.98-4.74-1.22v-3.17c0-1.66-1.35-3.01-3.01-3.01s-3.01 1.35-3.01 3.01v3.17c-1.65.24-3.24.62-4.74 1.22l-1.56-2.71c-.84-1.44-2.68-1.95-4.12-1.1a3.008 3.008 0 0 0-1.1 4.12l1.6 2.76a20.853 20.853 0 0 0-3.45 3.45l-2.76-1.6a3.01 3.01 0 0 0-4.12 1.1 3.022 3.022 0 0 0 1.1 4.12l2.71 1.56c-.6 1.5-.98 3.1-1.22 4.74h-3.17c-1.66 0-3.01 1.35-3.01 3.01s1.35 3.01 3.01 3.01h3.17c.24 1.65.62 3.25 1.22 4.75l-2.71 1.56a3.008 3.008 0 0 0-1.1 4.12c.56.97 1.57 1.51 2.61 1.51.51 0 1.03-.13 1.5-.41l2.76-1.6c1.02 1.28 2.16 2.44 3.45 3.45l-1.6 2.76a3.022 3.022 0 0 0 1.1 4.12c.48.28.99.41 1.5.41 1.04 0 2.05-.54 2.61-1.51l1.56-2.71c1.5.6 3.1.98 4.74 1.22v3.17c0 1.66 1.35 3.01 3.01 3.01s3.01-1.35 3.01-3.01v-3.17c1.65-.24 3.24-.62 4.74-1.22l1.56 2.71c.56.97 1.57 1.51 2.61 1.51.51 0 1.03-.13 1.5-.41a3.008 3.008 0 0 0 1.1-4.12l-1.6-2.76c1.28-1.02 2.44-2.16 3.45-3.45l2.76 1.6c.48.28.99.41 1.5.41 1.04 0 2.05-.54 2.61-1.51.83-1.44.34-3.28-1.1-4.12l-2.71-1.56c.6-1.5.98-3.1 1.22-4.75h3.17c1.66 0 3.01-1.35 3.01-3.01.05-1.66-1.3-3.01-2.97-3.01zm-23.87 18c-8.26 0-14.97-6.71-14.97-14.97 0-8.25 6.71-14.96 14.97-14.96s14.97 6.71 14.97 14.96-6.72 14.97-14.97 14.97z" />
              </svg>
            </a>
          </div>
          <!--SVG escudo -->

          <!-- Text Correspondencia -->
          <div class="col-9">
            <h6 class="text-center text-dark p-2 ml-1 mt-3 scalein animation-duration-1000">
              Correspondencia
            </h6>
          </div>
          <!-- Text Correspondencia -->

        </div>
      </a>

    </div>
  </nav>
</div>

<!-- Contenido -->
<div class="grid mx-1 mt-8 mb-8">

  <div class="col-12 text-center mt-8">

    <CardVue class="p-5">
        <template #header>

          <div class="flex align-items-center justify-content-center mt-8">

            <h1 class="px-1">
              <i class="fa-solid fa-4 fa-shake"
                style="--fa-animation-iteration-count: 1; --fa-animation-duration: 2.5s;"
              ></i>
            </h1>

            <h1 class="px-1">
              <i class="fa-solid fa-0 fa-shake"
                style="--fa-animation-iteration-count: 1; --fa-animation-duration: 2.5s;"
              ></i>
            </h1>

            <h1 class="px-1">
              <i class="fa-solid fa-4 fa-shake"
                style="--fa-animation-iteration-count: 1; --fa-animation-duration: 2.5s;"
              ></i>
            </h1>

          </div>
          
            
        </template>

        <template #title> 
          <h2>
            <i 
            class="fa-solid fa-link-slash fa-shake px-2"
            style="--fa-animation-iteration-count: 1; --fa-animation-duration: 2.5s;"
            ></i> Ruta no encontrada.
          </h2>
        </template>

        <template #content>
            <p>
              Si existe algún problema con el sistema póngase en contacto con nosotros.
            </p>
        </template>

        <template #footer>
          <a href="">
            <ButtonVue 
              icon="fa-solid fa-square-up-right" 
              label="Volver al Inicio" 
              severity="secondary"
            />
          </a>
        </template>
    </CardVue>

  </div>

</div>
<!-- Contenido -->



  <!-- Footer del Login -->
  <FooterComponent />
  <!-- Footer del Login -->

  <!-- Escudo SVG de Fondo -->
  <div class="backgroundGob"></div>
  <!-- Escudo SVG de Fondo -->


</template>

<script>
//import { useRouter } from "vue-router";
import FooterComponent from "@/modules/auth/components/FooterComponent.vue";

export default {
  components: {
    FooterComponent,
  },
  setup() {

  }
}
 
</script>


<style lang="scss" scoped>

.sinColor{
  font-size: 12px;
  color: #000000 !important;
}

.botonUsuarioAlt{
  font-size: 12px;
}

.textDropdown{
  color:#000000 !important ;
}

/* Colores SVG */
.EscudoLogost0 {
  fill: #6a0f49;
}

.gobDigitalLogost0 {
  fill: #69164a;
}

.gobDigitalLogost1 {
  fill: #6d807f;
}

.gobDigitalLogost2 {
  fill: #ffc3d0;
}

.gobDigitalLogost3 {
  fill: #69164a;
}

.LogoProyectost0 {
  fill: #69164a;
}

.LogoProyectost1 {
  fill: #6d807f;
}

/* Colores SVG */

/* Componentes PrimeVue */
.p-button,
.p-splitbutton {
  margin-bottom: 0.5rem;
}

::v-deep(.opcionesMenuCorrespondencia) {
  font-size: 14px;
  color:#000000;
}

::v-deep(.dark-panel.p-panel) {
  .p-panel-content {
    color: #000000;
  }

  .p-panel-header {
    background-color: #6a0f49;
  }

  .p-panel-title {
    color: #fff;
  }
}

::v-deep(.botonUsuario) {
  background-color: #4a001f;
  border-color: #80245f;
  transition: ease 1s;

  .p-button-icon {
    color: rgb(255, 255, 255);
  }

  .p-button-label {
    font-size: 13px;
  }
}

::v-deep(.chipUser){
  font-size: 12px;
  background-color: white;
}
::v-deep(.chipUser:hover){
  font-size: 12px;
  background-color: rgb(226, 226, 226);
}

::v-deep(.botonUsuario:hover) {
  background-color: #80245f;
  border-color: #4a001f;
  transition: ease 1s;

  .p-button-icon {
    color: rgb(255, 255, 255);
  }

  .p-button-label {
    font-size: 13px;
  }
}

::v-deep(.botonGobColor) {
  background-color: #4a001f;
  border-color: #80245f;
  transition: ease 1s;

  .p-button-icon {
    color: rgb(255, 255, 255);
  }

  .p-button-label {
    font-size: 15px;
  }
}

::v-deep(.botonGobColor:hover) {
  background-color: #80245f;
  border-color: #4a001f;
  transition: ease 1s;

  .p-button-icon {
    color: rgb(255, 255, 255);
  }

  .p-button-label {
    font-size: 15px;
  }
}

::v-deep(.botonGobColorCerrar) {
  background-color: #6d807f;
  border-color: #656e6e;
  transition: ease 1s;

  .p-button-icon {
    color: rgb(255, 255, 255);
  }

  .p-button-label {
    font-size: 15px;
  }
}

::v-deep(.botonGobColorCerrar:hover) {
  background-color: #656e6e;
  border-color: #6d807f;
  transition: ease 1s;

  .p-button-icon {
    color: rgb(255, 255, 255);
  }

  .p-button-label {
    font-size: 15px;
  }
}

@media only screen and (max-width: 600px) {

  ::v-deep(.opcionesUsuario) {
      font-size: 7px !important;
      height: 30px !important;
      max-height: 30px !important;

      background-color: #6d807f !important;
      border-color: #6d807f !important;
      transition: ease 1s;
    .p-button{
      font-size: 7px !important;
      height: 30px !important;
      max-height: 30px !important;

      background-color: #6d807f !important;
      border-color: #6d807f !important;
      transition: ease 1s;
    }
 
  }

  ::v-deep(.opcionesUsuario:hover) {
      font-size: 7px !important;
      height: 30px !important;
      max-height: 30px !important;

      background-color: #515151 !important;
      border-color: #515151 !important;
      transition: ease 1s;
    .p-button{
      font-size: 7px !important;
      height: 30px !important;
      max-height: 30px !important;

      background-color: #515151 !important;
      border-color: #515151 !important;
      transition: ease 1s;
    }
    
  }

}

@media only screen and (min-width: 600px) {

  ::v-deep(.opcionesUsuario) {
      font-size: 11px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #6d807f !important;
      border-color: #6d807f !important;
      transition: ease 1s;
    .p-button{
      font-size: 11px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #6d807f !important;
      border-color: #6d807f !important;
      transition: ease 1s;
      
    }
  }

  ::v-deep(.opcionesUsuario:hover) {
      font-size: 11px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #515151 !important;
      border-color: #515151 !important;
      transition: ease 1s;
    .p-button{
      font-size: 11px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #515151 !important;
      border-color: #515151 !important;
      transition: ease 1s;
      
    }
  }

}

@media only screen and (min-width: 768px) {

  ::v-deep(.opcionesUsuario) {
      font-size: 11px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #6d807f !important;
      border-color: #6d807f !important;
      transition: ease 1s;
    .p-button{
      font-size: 11px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #6d807f !important;
      border-color: #6d807f !important;
      transition: ease 1s;
      
    }
    
  }

  ::v-deep(.opcionesUsuario:hover) {
      font-size: 11px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #6d807f !important;
      border-color: #6d807f !important;
      transition: ease 1s;
    .p-button{
      font-size: 11px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #6d807f !important;
      border-color: #6d807f !important;
      transition: ease 1s;
      
    }

  }

}

@media only screen and (min-width: 992px) {

  ::v-deep(.opcionesUsuario) {
      font-size: 12px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #6d807f !important;
      border-color: #6d807f !important;
      transition: ease 1s;
    .p-button{
      font-size: 12px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #6d807f !important;
      border-color: #6d807f !important;
      transition: ease 1s;
      
    }
    
  }

  ::v-deep(.opcionesUsuario:hover) {
      font-size: 12px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #515151 !important;
      border-color: #515151 !important;
      transition: ease 1s;
    .p-button{
      font-size: 12px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #515151 !important;
      border-color: #515151 !important;
      transition: ease 1s;
      
    }

  }

}

@media only screen and (min-width: 1200px) {

  ::v-deep(.opcionesUsuario) {
      font-size: 13px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #6d807f !important;
      border-color: #6d807f !important;
      transition: ease 1s;
    .p-button{
      font-size: 13px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #6d807f !important;
      border-color: #6d807f !important;
      transition: ease 1s;
      
    }
  }

  ::v-deep(.opcionesUsuario:hover) {
      font-size: 13px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #515151 !important;
      border-color: #515151 !important;
      transition: ease 1s;
    .p-button{
      font-size: 13px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #515151 !important;
      border-color: #515151 !important;
      transition: ease 1s;
      
    }

  }

}

@media only screen and (min-width: 1515px) {
  
  ::v-deep(.opcionesUsuario) {
      font-size: 14px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #6d807f !important;
      border-color: #6d807f !important;
      transition: ease 1s;
    .p-button{
      font-size: 14px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #6d807f !important;
      border-color: #6d807f !important;
      transition: ease 1s;
      
    }

  }

  ::v-deep(.opcionesUsuario:hover) {
      font-size: 14px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #515151 !important;
      border-color: #515151 !important;
      transition: ease 1s;

    .p-button{
      font-size: 14px !important;
      height: 35px !important;
      max-height: 35px !important;

      background-color: #515151 !important;
      border-color: #515151 !important;
      transition: ease 1s;
      
    }
  
  }

}

/* Componentes PrimeVue */
</style>